<template>
  <div class="index">
    <section>
      <el-form class="section-filter" :model="filterForm" :inline="true" label-width="100px">
        <div class="filter-col">
          <el-form-item label="单位名称：">
            <el-input clearable v-model="filterForm.o_name" placeholder="请输入单位名称"></el-input>
          </el-form-item>
          <el-form-item label="申请状态：">
            <el-select clearable v-model="filterForm.status" placeholder="请选择申请状态">
              <el-option v-for="(x,i) in $fuwuData.companyApplyStatus" :key="i" :label="x.label" :value="x.value">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="起始时间">
            <el-date-picker
              type="year" default-time="00:00:00" v-model="filterForm.startCostSeconds" :style="'width:200px;'"
              format="yyyy" value-format="timestamp" placeholder="选择时间"></el-date-picker>
          </el-form-item> -->
          <!-- <el-form-item label="截止时间">
            <el-date-picker
              type="year" default-time="00:00:00" v-model="filterForm.endCostSeconds" :style="'width:200px;'"
              format="yyyy" value-format="timestamp" placeholder="选择时间"></el-date-picker>
          </el-form-item> -->
        </div>
        <div class="filter-area">
          <div class="filter-area-label">地区：</div>
          <AreaPicker ref="AreaPicker" @getData="filterHandler" />
        </div>
        <div class="filter-btn">
          <el-button type="primary" @click="filterHandler()" icon="el-icon-search">查询</el-button>
          <el-button type="" @click="resetHandler()" icon="el-icon-refresh-right">重置</el-button>
        </div>
      </el-form>
    </section>
    <!-- 数据表格 -->
    <div class="table">
      <el-table :data="tableData" border>
        <el-table-column show-overflow-tooltip v-for="(x,i) in tableInfo" :key="i" :prop="x.key" :label="x.label" align="center"></el-table-column>
        <el-table-column label="审核状态" prop="status" align="center">
          <template slot-scope="scope">
            <el-select v-model="scope.row.status" placeholder="请选择状态">
              <el-option v-for="(x,i) in $fuwuData.companyApplyStatus" :key="i" :label="x.label" :value="x.value"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="150px">
          <template slot-scope="scope">
            <el-button type="primary" @click="modifyHandler(scope.row)" v-if="btnShow.modify">确认</el-button>
            <el-button type="danger" @click="deleteHandler(scope.row.id)" v-if="btnShow.delete">删除</el-button>
          </template>
        </el-table-column>
        <el-table-column label="查看信息" type="expand">
          <template slot-scope="scope">
            <div class="detailbox">
              <li class="li">
                <span>上传审核图片：</span>
                <!-- <template v-if="scope.row.o_img">
                  <span class="imgspan" v-for="(x,i) in scope.row.o_img" :key="i">
                    <el-image
                      style="width: 100px; height: 100px" :src="puUrl_x+'/'+x"
                      :preview-src-list="previewImgList" @click="previewImg(scope.row.imgId,i)"></el-image>
                  </span>
                </template> -->
                <template v-if="scope.row.o_img">
                  <span class="imgspan">
                    <el-image style="width: 100px; height: 100px" :src="puUrl_x+'/'+scope.row.o_img" :preview-src-list="[_img_handler(scope.row.o_img)]"></el-image>
                  </span>
                </template>
                <template v-else>
                  <span class="imgspan">未上传营业执照</span>
                </template>
              </li>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <paging :pagesData="pageData" @set_page_number="pageChange"></paging>
  </div>
</template>

<script>
import AreaPicker from '@/components/AreaPicker'
import { powerMap } from '@/publicData/powerData'
export default {
  components: { AreaPicker },
  data() {
    return {
      sign: 'qiyesq',
      tableData: [],//请求到的 ‘律师请求’ 数据，渲染到表格中
      filterForm: {},//查询数据表单
      tableInfo:[
        { key: 'province', label: '省', fixed: true },
        { key: 'city', label: '市', fixed: true },
        { key: 'county', label: '县', fixed: true },
        { key: 'town', label: '镇', fixed: true },
        { key: 'village', label: '村', fixed: true },

        // { label: '申请账号', key: 'user' },
        // { label: '申请人', key: 'user.u_nickName' },
        // { label: '申请账号', key: 'user.name' },
        { label: '企业名称', key: 'o_name' },
        { label: '申请时间', key: 'showDate' },
      ],
      previewImgList:[],//预览模式下的图片数组
      
      //分页数据
      pageData: {
        currentPage: 1,
        pageSize: 40,
        total: 0,
      },
      btnShow: {
        search: false,
        create: false,
        modify: false,
        delete: false,
        import: false,
        export: false,
      }, // 权限显隐
    }
  },
  methods:{
    // 后台 服务方面的 分页
    pageChange(pageNumer) {
      this.pageData.currentPage = pageNumer
      this.filterForm.pageNumber = pageNumer
      this.searchHandler()
    },
    // 点击图片，进行预览
    previewImg(arr, index) {
      this.previewImgList = new Array(arr.length)
      arr.forEach((x, i) => {
        // 当遍历索引大于点击对应的索引时，将这个值赋给 索引为i-index的元素
        // 当遍历索引小于点击对应的索引时，将这个值赋给 索引为i+length-index的元素
        let imgUrl = this.puUrl_x + '/' + x
        if (i >= index) {
          this.previewImgList[i - index] = imgUrl
        } else {
          this.previewImgList[i + arr.length - index] = imgUrl
        }
      })
    },
    filterHandler(areaId) {
      this.pageData.currentPage = 1
      this.searchHandler(areaId)
    },
    searchHandler(areaId) {
      areaId ? '' : areaId = this.$refs.AreaPicker.findAreaId()
      let rD = JSON.parse(JSON.stringify(this.filterForm))
      rD.areaId = areaId
      this.getData(rD)
    },
    resetHandler() {
      this.filterForm = this.filterForm_ori ? JSON.parse(JSON.stringify(this.filterForm_ori)) : {}
      if (this.$refs.AreaPicker) {
        this.$refs.AreaPicker.reset()
      }
    },
    modifyHandler(row) {//更改审核状态
      let { id, status } = row
      let rD = { id, status }
      this.$api.util_modify(this.sign, rD).then(res => {
        if (res.data.status == 0) {
          this.$message.success('审核状态已更新！')
          this.searchHandler()
        } else { this._status(res.data) }
      })
    },
    // 删除
    deleteHandler(id) {
      let rD = { ids: [id] }
      this.$confirm('确认删除数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.util_delete(this.sign, rD).then(res => {
          if (res.data.status === 0 ) {
            this.$message.success('删除成功！')
            // —————————————————— 把当前页的所有数据都删除时，需要更换页码 s ——————————————————
            let nowtotal = this.pageData.total - 1
            if (nowtotal % this.pageData.pageSize === 0) {
              if (this.pageData.currentPage > 1) {
                this.pageData.currentPage--
              } else {
                this.pageData.currentPage = 1
              }
            }
            // —————————————————— 把当前页的所有数据都删除时，需要更换页码 e ——————————————————
            console.log('删除后总条数',nowtotal,'当前页数',this.pageData.currentPage)
            this.searchHandler()
          } else { this._status(res.data) }
        })
      }).catch(() => {})

    },
    getData(rD = {}) {
      rD.pageNumber = this.pageData.currentPage
      this.$api.util_search(this.sign, rD).then(res => {
        if (res.data.status == 0) {
          this.tableData = JSON.parse(res.data.data)
          this.pageData.total = res.data.size
          console.log(this.tableData)
        } else { this._status(res.data) }
      })
    },
  },
  created() {
    const powerList = this.userInfo.privilegesList
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 特殊处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
    const powerStr = powerMap[this.sign]
    // console.log(powerStr)
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 特殊处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
    const mapList = ['search','create','modify','delete','import','export']
    if (this.userInfo.admin) {
      mapList.forEach(x => {
        this.btnShow[x] = true
      })
    } else {
      mapList.forEach(x => {
        if (x && powerList.includes(powerStr + '-' + x)) {
          this.btnShow[x] = true
        } else if (!x) {
          this.btnShow.search = true
        }
      })
    }
  },
}
</script>

<style lang='scss' scoped>
.section-filter{display: flex;overflow-x: auto;}
.section-filter>div{flex-shrink: 0;}
.filter-col{display: flex;flex-direction: column;}
.filter-area{display: flex;}
.filter-area-label{margin:5px 10px 0 50px;font-size: 14px;}
.filter-btn{margin-left: 20px;}

</style>